import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconAimbulanceComponent } from "./med-icon-aimbulance.component";

@NgModule({
  declarations: [
    MedIconAimbulanceComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconAimbulanceComponent,
  ],
})
export class MedIconAimbulanceModule { }
